export default {
    "Home": "Home",
    "Dashboard": "Dashboard",
    "Current players total balance": "Current devices total balance",
    "Total active players count": "Total active devices count",
    "Players": "Devices",
    "Players List": "Devices List",
    "Back to Players List": "Back to Devices List",
    "Back to Player Detail": "Back to Device Detail",
    "Username": "Username",
    "Created At": "Created At",
    "Actions": "Actions",
    "Create": "Create",
    "Create Player": "Create Device",
    "New Player": "New Device",
    "Activate": "Activate",
    "Deactivate": "Deactivate",
    "View": "View",
    "Details": "Details",
    "Next": "Next",
    "Previous": "Previous",
    "Filter": "Filter",
    "Reset": "Reset",
    "Search": "Search",
    "Random Username": "Random Username",
    "Status": "Status",
    "Active": "Active",
    "Inactive": "Inactive",
    "No open withdrawals": "No open withdrawals",
    "Open Withdrawal": "Open Withdrawal",
    "Current player's balance": "Current device's balance",
    "Accept": "Accept",
    "Deposit": "Deposit",
    "Balance": "Balance",
    "Withdraw": "Withdraw",
    "Withdrawal of": "Withdrawal of",
    "for": "for",
    "of": "of",
    "Amount": "Amount",
    "PIN": "PIN",
    "Games": "Games",
    "No Entries": "No Entries",
    "Change Password": "Change password",
    "Current password": "Current Password",
    "New Password": "New Password",
    "New Password Confirmation": "New Password Confirmation",
    "Stats": "Stats",
    "Login": "Login",
    "Please activate the player before depositing": "Please activate the device before depositing",
    "Logout": "Logout",
    "History": "History",
    "Type": "Type",
    "All": "All",
    "Stats Per Game": "Stats Per Game",
    "Stats Per Device": "Stats Per Device",
    "Are you sure you want to deposit - ": "Are you sure you want to deposit - ",
    "Are you sure you want to withdraw - ": "Are you sure you want to withdraw - ",
    "Please show this code to cashier": "Please show this code to cashier",
    "Cancel withdrawal": "Cancel withdrawal",
    "and continue playing": "and continue playing",
    "Withdraw money": "Withdraw money",
    "Custom Amount": "Custom Amount",
    "Bingo": "Bingo",
    "Slot": "Slot",
    "No game found": "No game found",
    "From": "From",
    "To": "To",
    "Hold": "Profit",
    "Bets": "Stakes",
    "Wins": "Returns",
    "Game Name": "Game",
    "Share": "Share",
    "New Withdrawal": "New Withdrawal",
    "Spins": "Spins",
    "Stake/Spin": "Stake/Spin",
    "Totals": "Totals",
    "Save Changes": "Save Changes",
    "Save": "Save",
    "Last Login": "Last Login",
    "Never": "Never",
    "Back": "Back",
    "Withdrawals": "Withdrawals",
    "Withdrawal": "Withdrawal",
    "Deposits": "Deposits",
    "Go Home": "Go Home",
    "Business Day": "Business Day",
    "Accounting": "Accounting",
    "requested a withdrawal": "requested a withdrawal",
    "canceled a withdrawal": "canceled a withdrawal",
    "Lobby": "Lobby",
    "Sorry": "Sorry",
    "Game is not available": "Game is not available",
    "Withdrawal error": "Withdrawal error",
    "Insufficient funds": "Insufficient funds",
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "Are you sure you want to withdraw all funds?": "Are you sure you want to withdraw all funds?",
    "Cancel Withdrawal": "Cancel Withdrawal",
    "Are you sure you want to cancel withdrawal request?": "Are you sure you want to cancel withdrawal request?",
    "Yes": "Yes",
    "No": "No",
    "Withdrawal canceled": "Withdrawal canceled",
    "Please wait": "Please wait",
    "Force reload": "Force reload",
    "Are you sure you want to reload player page?": "Are you sure you want to reload player page?",
    "impersonated as": "impersonated as",
    "Summary per location": "Summary per bar",
    "Summary per operator": "Summary per bar manager",
    "Deposits total sum": "Deposits total sum",
    "Withdrawals total sum": "Withdrawals total sum",
    "Withdrawals pending count": "Withdrawals pending count",
    "Unlock Withdrawals": "Unlock Withdrawals",
    "Withdrawal confirmation text": "Are you sure you want to unlock withdrawals? All open games will be closed.",
    "Terminal withdrawals are unblocked": "Terminal withdrawals are unblocked",
    "Withdraw all from player confirmation": "Are you sure you want to withdraw players money?",
    "You have unfinished rounds!": "You have unfinished rounds!",
    "Open game": "Open game",
}
